import * as drayageCannedResponsesTables from "@/utils/OTR/drayageCannedResponsesTables";

export default {
  namespaced: true,
  state: {
    dayageCannedResponsesTables: {
      "GENERAL TABLE": drayageCannedResponsesTables.GENERAL_TABLE,
      "NY/NJ": drayageCannedResponsesTables.NY_NJ_DRAYAGE_TABLE,
      CALIFORNIA: drayageCannedResponsesTables.CALIFORNIA_DRAYAGE_TABLE,
      BALTIMORE: drayageCannedResponsesTables.BALTIMORE_DRAYAGE_TABLE,
      BOSTON: drayageCannedResponsesTables.BOSTON_DRAYAGE_TABLE,
      OAKLAND: drayageCannedResponsesTables.OAKLAND_DRAYAGE_TABLE,
      CHICAGO: drayageCannedResponsesTables.CHICAGO_DRAYAGE_TABLE,
      KANSAS: drayageCannedResponsesTables.KANSAS_DRAYAGE_TABLE,
      "CINCINNATI COLUMBUS":
        drayageCannedResponsesTables.CINCINNATI_COLUMBUS_DRAYAGE_TABLE,
      MIAMI: drayageCannedResponsesTables.MIAMI_DRAYAGE_TABLE,
      "PORT EVERGLADES":
        drayageCannedResponsesTables.PORT_EVERGLADES_DRAYAGE_TABLE,
      MEMPHIS: drayageCannedResponsesTables.MEMPHIS_DRAYAGE_TABLE,
      MINNEAPOLIS: drayageCannedResponsesTables.MINNEAPOLIS_DRAYAGE_TABLE,
      ATLANTA: drayageCannedResponsesTables.ATLANTA_DRAYAGE_TABLE,
      HOUSTON: drayageCannedResponsesTables.HOUSTON,
      "NEW ORLEANS": drayageCannedResponsesTables.NEW_ORLEANS,
      NORFOLK: drayageCannedResponsesTables.NORFOLK,
      DETROIT: drayageCannedResponsesTables.DETROIT_DRAYAGE_TABLE,
      CHARLESTON: drayageCannedResponsesTables.CHARLESTON_DRAYAGE_TABLE,
      //TEMP CONTROL: drayageCannedResponsesTables.
      "DRAYAGE QUOTE GENERAL":
        drayageCannedResponsesTables.DRAYAGE_QUOTE_GENERAL,
      "DRAYAGE QUOTE NY NJ": drayageCannedResponsesTables.DRAYAGE_QUOTE_NY_NJ,
      "DRAYAGE CALIFORNIA LA LB":
        drayageCannedResponsesTables.DRAYAGE_CALIFORNIA_LA_LB,
      MIAMITC: drayageCannedResponsesTables.DRAYAGE_QUOTE_MIAMI,
      CHICAGOTC: drayageCannedResponsesTables.DRAYAGE_QUOTE_CHICAGO,
      HOUSTONTC: drayageCannedResponsesTables.HOUSTON_TEMP_CONTROL,
      "NEW ORLEANS TC": drayageCannedResponsesTables.NEW_ORLEANS_TEMP_CONTROL,
      NORFOLKTC: drayageCannedResponsesTables.NORFOLK_TEMP_CONTROL,
      BOSTONTC: drayageCannedResponsesTables.BOSTON_TEMP_CONTROL,
      "CINCINNATI COLOMBUS TC":
        drayageCannedResponsesTables.CINCINNATI_COLOMBUS_TEMP_CONTROL,
      SAVANNAHTC: drayageCannedResponsesTables.SAVANNAH_TEMP_CONTROL,
      OAKLANDTC: drayageCannedResponsesTables.OAKLAND_TEMP_CONTROL,
      "KANSAS CITY TC": drayageCannedResponsesTables.KANSAS_CITY_TEMP_CONTROL,
      MINNEAPOLISTC: drayageCannedResponsesTables.MINNEAPOLIS_TEMP_CONTROL,
      BALTIMORETC: drayageCannedResponsesTables.BALTIMORE_TEMP_CONTROL,
      "PORT EVERGLADES TC":
        drayageCannedResponsesTables.PORT_EVERGLADES_TEMP_CONTROL,
      MEMPHISTC: drayageCannedResponsesTables.MEMPHIS_TEMP_CONTROL,
      ATLANTATC: drayageCannedResponsesTables.ATLANTA_TEMP_CONTROL
    }
  },

  getters: {
    showDrayageCannedResponsesTables(state) {
      return state.dayageCannedResponsesTables;
    }
  }
};
